<template>
  <div>
    <b-col class="p-0">
      <div>
        <b-card no-body align="center">
          <b-card-header size="sm">
            <router-link :to="{ name: 'File Details', params: { size: size, checksum: checksum }}">{{ name ? name : 'No Name' }}</router-link>
            <div><small>{{ size | bytes }}</small></div>
            <checksum-list v-if="entity " :checksums="allChecksums"></checksum-list>
          </b-card-header>
          <entity-media-wrapper v-if="entity" :entity="entity.toObject()"></entity-media-wrapper>

<!--          <b-container v-if="entity" class="d-flex flex-row justify-content-center">-->
<!--            <div v-if="videos" class="embed-responsive embed-responsive-16by9">-->
<!--              <video-player :entity="entity.toObject()" class="embed-responsive-item"></video-player>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              <b-img v-for="thumb in thumbs" :key="thumb.getChecksum()" :src="thumb.getSignedUrl()" class="p-1" height="60"></b-img>-->
<!--            </div>-->
<!--          </b-container>-->

          <b-card-footer>
            <vue-tags-input
              input-id="file-detail-tags"
              v-model="tag"
              :tags="tags"
              @before-adding-tag="beforeTagAdd"
              @before-deleting-tag="beforeTagDelete"
            />
          </b-card-footer>
        </b-card>
      </div>
    </b-col>
  </div>
</template>

<script>
import { VueTagsInput, createTag } from '@johmun/vue-tags-input';
import { EntityGetSession } from '#/services/entities';
import { EntityId } from '#/protobuf/entity_pb';
import { EntityTagUpdateRequest } from '#/protobuf/service_modification_pb';
import ChecksumList from '#/ui/Components/ChecksumList.vue';
import { entityHasVideoDerivs } from '#/models/entities/entity';
import EntityMediaWrapper from '#/ui/Components/Entities/EntityMediaWrapper.vue';

export default {
  components: {
    EntityMediaWrapper,
    ChecksumList,
    VueTagsInput,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    checksum: {
      type: String,
      default() {
        return this.$route.params.checksum;
      },
    },
    size: {
      type: Number,
      default() {
        return Number(this.$route.params.size);
      },
    },
  },
  data() {
    const { size, checksum } = this;
    const eId = new EntityId();
    eId.setSize(size);
    eId.setChecksum(checksum);
    return {
      session: new EntityGetSession([eId]),
      tag: '',
      tags: [],
    };
  },
  computed: {
    entityId() {
      const { size, checksum } = this;
      const entityId = new EntityId();
      entityId.setSize(size);
      entityId.setChecksum(checksum);
      return entityId;
    },
    entity() {
      return this.session.entity;
    },
    hasVideo() {
      return entityHasVideoDerivs(this.entity) !== undefined;
    },
    dateUpdated() {
      return this.entity.getDateLastUpdated();
    },
    allChecksums() {
      return this.entity.getAlternateChecksums().toObject();
    },
  },
  methods: {
    beforeTagAdd(obj) {
      console.log('TAG beforeTagAdd', obj.tag.text, this.entityId.getSize(), this.entityId.getChecksum());
      const tag = [obj.tag.text];
      const request = new EntityTagUpdateRequest();
      request.setEntityId(this.entityId);
      request.setTagsToAddList(tag);
      this.$store.dispatch('entities/updateTags', request).then((response) => {
        console.log('successfully added tag:', response);
        obj.addTag();
      }).catch((error) => {
        console.log('ERROR adding tag:', error);
        alert('Error adding tag', error);
      });
    },
    beforeTagDelete(obj) {
      console.log('TAG beforeTagDelete', obj.tag.text, this.entityId.getSize(), this.entityId.getChecksum());
      const tag = [obj.tag.text];
      const request = new EntityTagUpdateRequest();
      request.setEntityId(this.entityId);
      request.setTagsToRemoveList(tag);
      this.$store.dispatch('entities/updateTags', request).then((response) => {
        console.log('successfully deleted tag:', response);
        obj.deleteTag();
      }).catch((error) => {
        console.log('ERROR removing tag:', error);
        alert('Error removing tag', error);
      });
    },
  },
  created() {
    if (!this.checksum || !this.size) {
      console.error('ERROR: file detail card missing checksum', this.checksum, 'or size', this.size);
      return Promise.reject(new Error('details missing checksum or size data'));
    }
    return this.session.load().then(() => {
      const entity = this.session.entity.toObject();
      if (entity) {
        entity.expandedTagsList.forEach((tag) => {
          const obj = createTag(tag.tag, this.tags);
          this.tags.push(obj);
        });
      }
    });
    /*
    console.log('file detail card created', this.entityId);
    const request = new EntityGetRequest();
    const expansionRequest = new EntityInfoExpansionRequest();
    expansionRequest.setShouldExpandMetadata(true);
    expansionRequest.setShouldExpandTags(true);
    expansionRequest.setShouldExpandJobMembership(true);
    expansionRequest.setShouldExpandThumbnail(true);
    expansionRequest.setShouldExpandVideo(true);
    expansionRequest.setShouldExpandAudio(true);
    expansionRequest.setShouldExpandReport(true);
    request.setExpansionRequest(expansionRequest);
    request.setEntityIdsList([this.entityId]);

    this.$store.dispatch('entities/loadDetails', request).then((response) => {
      const [entity] = response.getEntitiesList();
      console.log('ENTITY DETAILS', response.toObject());
      this.entity = entity;

      const tagsList = this.entity.getExpandedTagsList();
      tagsList.forEach((tag) => {
        const obj = createTag(tag.getTag(), this.tags);
        this.tags.push(obj);
      });
      console.log('loaded file details', this.entity.toObject());
    }).catch((error) => {
      console.log('promise rejected for entity card: ', error);
    });

     */
  },
};
</script>

<style scoped>
.vue-tags-input {
  max-width: 100% !important;
}

.video-wrapper {
  height: 500px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.video-wrapper > video {
  width: 100%;
}
</style>
